import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";

// Stashes a referrer code from /r/:code URLs so checkout can attribute the order.
export default function ReferralCatch() {
  const { code } = useParams();
  const nav = useNavigate();
  useEffect(() => {
    if (code) {
      localStorage.setItem("brunchi_referrer_code", code.toUpperCase());
      toast.success(`Friend discount unlocked · 10% off applied at checkout`);
    }
    nav("/", { replace: true });
  }, [code, nav]);
  return <div className="text-center py-20">Welcome to Brunchi…</div>;
}
